<template>
  <div class="foot" :style="`background-color:${theme.footerColor}`">
    <router-link class="foot-item" v-for="item in foot" :key="item.path" :to="item.path">
      <i class="icon" :class="getIcon(item.icon)"></i>
      <span class="foot-title">{{item.title}}</span>
    </router-link>
  </div>
</template>

<script>
import '../assets/less/footer.less'
export default {
  data(){
    return {
      foot: [
        {
          path: '/',
          title: '相册',
          icon: 'photo'
        },
        {
          path: '/cllection',
          title: '我的收藏',
          icon: 'collect'
        },
        {
          path: '/myPhoto',
          title: '照片',
          icon: 'pic'
        }
      ]
    }
  },
  props:{
    theme: {
      type: Object,
      default: function(){
        return {
          footerColor: "#fff",
          bgColor: "#fff",
          searchBgColor: "#fff"
        }
      }
    }
  },
  methods: {
    getIcon(icon){
      let meta = this.$route.meta
      if(meta.icon == icon){
        return icon + '-active'
      } else {
        return icon
      }
    }
  }
}
</script>

<style>

</style>